"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFdrAutocompleteCountContext = exports.FdrAutocompleteCountConsumer = exports.FdrAutocompleteCountProvider = exports.fdrAutocompleteCountReducer = exports.FdrAutocompleteCountActionType = exports.FdrAutocompleteCountContext = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const fdr_lib_apollo_query_1 = require("@hotelplan/fdr.lib.apollo.query");
const initialAutocompleteState = {
    items: [],
};
exports.FdrAutocompleteCountContext = (0, react_1.createContext)(Object.assign(Object.assign({}, initialAutocompleteState), { putItem: noop_1.default, removeItem: noop_1.default, clear: noop_1.default }));
var FdrAutocompleteCountActionType;
(function (FdrAutocompleteCountActionType) {
    FdrAutocompleteCountActionType["PUT_ITEM"] = "PUT_ITEM";
    FdrAutocompleteCountActionType["REMOVE_ITEM"] = "REMOVE_ITEM";
    FdrAutocompleteCountActionType["UPDATE_ITEM"] = "UPDATE_ITEM";
    FdrAutocompleteCountActionType["CLEAR"] = "CLEAR";
})(FdrAutocompleteCountActionType || (exports.FdrAutocompleteCountActionType = FdrAutocompleteCountActionType = {}));
function fdrAutocompleteCountReducer(prevState, action) {
    const map = new Map(prevState.items.map(item => [item.id, item]));
    switch (action.type) {
        case FdrAutocompleteCountActionType.PUT_ITEM:
            map.set(action.item.id, Object.assign(Object.assign({}, action.item), { count: null, loading: false }));
            return Object.assign(Object.assign({}, prevState), { items: Array.from(map, entry => entry[1]) });
        case FdrAutocompleteCountActionType.REMOVE_ITEM:
            map.delete(action.id);
            return Object.assign(Object.assign({}, prevState), { items: Array.from(map, entry => entry[1]) });
        case FdrAutocompleteCountActionType.UPDATE_ITEM:
            map.set(action.item.id, Object.assign({}, action.item));
            return Object.assign(Object.assign({}, prevState), { items: Array.from(map, entry => entry[1]) });
        case FdrAutocompleteCountActionType.CLEAR:
            return Object.assign(Object.assign({}, prevState), { items: [] });
    }
    return prevState;
}
exports.fdrAutocompleteCountReducer = fdrAutocompleteCountReducer;
function FdrAutocompleteCountProvider(props) {
    const { queryDocument, dataMapper, variablesMapper, children } = props;
    const [state, dispatch] = (0, react_1.useReducer)(fdrAutocompleteCountReducer, initialAutocompleteState);
    const handlers = (0, react_1.useMemo)(() => ({
        putItem(item) {
            dispatch({ type: FdrAutocompleteCountActionType.PUT_ITEM, item });
        },
        removeItem(id) {
            dispatch({ type: FdrAutocompleteCountActionType.REMOVE_ITEM, id });
        },
        clear() {
            dispatch({ type: FdrAutocompleteCountActionType.CLEAR });
        },
    }), []);
    const context = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, state), handlers)), [handlers, state]);
    return (react_1.default.createElement(exports.FdrAutocompleteCountContext.Provider, { value: context },
        state.items.map(item => {
            return (react_1.default.createElement(FdrAutocompleteCountContextItem, { key: item.id, item: item, dispatch: dispatch, queryDocument: queryDocument, dataMapper: dataMapper, variablesMapper: variablesMapper }));
        }),
        children));
}
exports.FdrAutocompleteCountProvider = FdrAutocompleteCountProvider;
function FdrAutocompleteCountContextItem(props) {
    const { item, queryDocument, dataMapper, variablesMapper, dispatch } = props;
    const { data, loading } = (0, fdr_lib_apollo_query_1.useQuery)(queryDocument, {
        ssr: false,
        variables: variablesMapper(item.items),
    });
    (0, react_1.useEffect)(() => {
        if (loading) {
            dispatch({
                type: FdrAutocompleteCountActionType.UPDATE_ITEM,
                item: Object.assign(Object.assign({}, item), { loading: true, count: null }),
            });
        }
        else if (data) {
            dispatch({
                type: FdrAutocompleteCountActionType.UPDATE_ITEM,
                item: Object.assign(Object.assign({}, item), { loading: false, count: dataMapper(data) }),
            });
        }
    }, [loading, data, item.count]);
    return null;
}
function FdrAutocompleteCountConsumer(props) {
    return (react_1.default.createElement(exports.FdrAutocompleteCountContext.Consumer, null, props.children));
}
exports.FdrAutocompleteCountConsumer = FdrAutocompleteCountConsumer;
function useFdrAutocompleteCountContext() {
    return (0, react_1.useContext)(exports.FdrAutocompleteCountContext);
}
exports.useFdrAutocompleteCountContext = useFdrAutocompleteCountContext;
//# sourceMappingURL=index.js.map